import React,{useState,useEffect} from 'react'
import MaterialTable from 'material-table';
import Axios from 'axios';
import AddEditSalesMain from './AddEditSalesMain';

import Sales from './Sales';

import {  MDBContainer, MDBRow, MDBCol, MDBIcon, MDBCardBody, MDBCardText,  MDBCardTitle } from "mdbreact";



const CustomerTicketMain=(props)=>{

    const [parentcode,setParentCode]=useState('');

  return (
    <React.Fragment > 
        <MDBRow className="pt-5">
            <MDBCol md="3">
                {/* <h1>{parentcode}</h1> */}
            <AddEditSalesMain 
            
            deployURL={props.deployURL}
                         apiServer={props.apiServer}
                        
                       
                         apiServerHybrid={props.apiServerHybrid}
                         setParentCode={setParentCode}
                      
                        
                        />
            </MDBCol>
            <MDBCol md="9">
                { parentcode ==="" ?
                  (
                      
                    <MDBContainer className="mt-5 text-center" fluid>
                    <MDBRow>
                        <MDBCol>
                        
                            <MDBCardBody>
                            
                        <MDBCardTitle className="h2">
                                <b>
                            Warning</b>
                            </MDBCardTitle>
                            <p className="red-text my-4 font-weight-bold">
                                <MDBIcon icon="exclamation-circle" size="9x" color="blue-text"></MDBIcon>
                        
                            </p>
                            <MDBCardText>
                                Please save Customer Ticket to proceed with the Charging Module.
                            </MDBCardText>
                            <hr className="my-4" />
                            <div className="pt-2">
                            
                            </div>  

                {/* <img src={process.env.PUBLIC_URL + "/loading.gif"} style={{width:"300px",textAlign:"center"}} alt="loading" />
                            <h3 className="h3-responsive">Please wait while we are processing your request.</h3> */}
                            </MDBCardBody>
                        
                        </MDBCol>
                    </MDBRow>
                    </MDBContainer>
                  )
                  :
                  (<Sales
                    deployURL={props.deployURL}
                    apiServer={props.apiServer}
                   
                  
                    parentcode={parentcode}
                    apiServerHybrid={props.apiServerHybrid}
                 
                   
                   >
           </Sales>)
                  }
            
                
            </MDBCol>
        </MDBRow>
           
                  
    </React.Fragment>
   
  )
}



export default CustomerTicketMain
